import { Modal, notification } from "antd";
import { useState, useEffect } from "react";
import { Api } from "../../common/Api";
import { useFilters, baseFilters } from "../useFilters";

export const usePostComments = () => {
  const [data, setData] = useState({ total: 0, items: [] });
  const [loading, setLoading] = useState(false);

  const { filters, setFilters, refreshKey, search, refresh, reset, getFiltersData, sortedInfo, setSortedInfo } =
    useFilters(baseFilters());

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      Api.content.post
        .comments(getFiltersData())
        .then((res) => {
          setData(res.data.postComments);
        })
        .finally(() => setLoading(false));
    };

    fetchData();
  }, [refreshKey]);

  const onSearch = () => {
    search({ page: 0 });
  };

  const onPage = (page, size) => {
    search({ page: page - 1, size });
  };

  const del = (item) => {
    Modal.confirm({
      content: "Are you sure to DELETE it?",
      onOk: () => {
        return Api.content.post.delComment(item.CommentId).then(() => {
          notification.success({ message: `Deleted Successfully` });
          setTimeout(refresh, 1000);
        });
      },
    });
  };

  return {
    data,
    loading,
    refresh,
    onSearch,
    reset,
    onPage,
    filters,
    setFilters,
    del,
    pagination: {
      current: filters.page + 1,
      pageSize: filters.size,
      total: data.total,
      onChange: onPage,
    },
    sortedInfo,
    setSortedInfo,
  };
};
